import React from 'react';
import { Navigate } from 'react-router-dom';
import useGuidedFlowVm from '|/app/purchase/flow/guided-flow/use-guided-flow-vm';

const GuidedFlow = () => {
  const newRoute = useGuidedFlowVm();
  return newRoute === null ? null : <Navigate to={newRoute} replace={true} />;
};

export default GuidedFlow;
